import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonBreadcrumb } from './Breadcrumb.definition';
import { chameleonBreadcrumbItem } from './BreadcrumbItem/BreadcrumbItem.definition';
import { chameleonMenu } from '../Menu/Menu.definition';
import { chameleonPopoverV2 } from '../PopoverV2/PopoverV2.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonBreadcrumb({ prefix }), chameleonBreadcrumbItem({ prefix }), chameleonMenu({ prefix }), chameleonPopoverV2({ prefix }));
}
